import grid from './grid';
import info from './info';

export default function(action, page) {
  if (action === 'grid') grid();
  if (action === 'info') info();
}